/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fixture_CancelInputs */

const th_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิก`)
};

const en_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const ja_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const zh_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const es_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const pt_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const id_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batal`)
};

const fr_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const tl_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanselahin`)
};

const vi_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ`)
};

const ko_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`취소`)
};

const de_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const ru_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const tr_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vazgeç`)
};

const it_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla`)
};

const pl_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuluj`)
};

const uk_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скасувати`)
};

const hi_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करें`)
};

const ar_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إلغاء`)
};

const ms_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batal`)
};

const bn_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বাতিল`)
};

const zh_tw2_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const zh_hk2_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ur_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منسوخ`)
};

const fa_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انصراف`)
};

const sw_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghairi`)
};

const nl_fixture_cancel = /** @type {(inputs: Fixture_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuleren`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Fixture_CancelInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const fixture_cancel = /** @type {((inputs?: Fixture_CancelInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fixture_CancelInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_fixture_cancel(inputs)
	if (locale === "ja") return ja_fixture_cancel(inputs)
	if (locale === "zh") return zh_fixture_cancel(inputs)
	if (locale === "es") return es_fixture_cancel(inputs)
	if (locale === "pt") return pt_fixture_cancel(inputs)
	if (locale === "id") return id_fixture_cancel(inputs)
	if (locale === "fr") return fr_fixture_cancel(inputs)
	if (locale === "tl") return tl_fixture_cancel(inputs)
	if (locale === "vi") return vi_fixture_cancel(inputs)
	if (locale === "ko") return ko_fixture_cancel(inputs)
	if (locale === "de") return de_fixture_cancel(inputs)
	if (locale === "ru") return ru_fixture_cancel(inputs)
	if (locale === "tr") return tr_fixture_cancel(inputs)
	if (locale === "it") return it_fixture_cancel(inputs)
	if (locale === "pl") return pl_fixture_cancel(inputs)
	if (locale === "uk") return uk_fixture_cancel(inputs)
	if (locale === "hi") return hi_fixture_cancel(inputs)
	if (locale === "ar") return ar_fixture_cancel(inputs)
	if (locale === "ms") return ms_fixture_cancel(inputs)
	if (locale === "bn") return bn_fixture_cancel(inputs)
	if (locale === "zh-TW") return zh_tw2_fixture_cancel(inputs)
	if (locale === "zh-HK") return zh_hk2_fixture_cancel(inputs)
	if (locale === "ur") return ur_fixture_cancel(inputs)
	if (locale === "fa") return fa_fixture_cancel(inputs)
	if (locale === "sw") return sw_fixture_cancel(inputs)
	if (locale === "nl") return nl_fixture_cancel(inputs)
	return en_fixture_cancel(inputs)
});